export default __webpack_public_path__ + "static/media/twitter.1105c1a1.jpeg";